enum Codenames {
  UPI = "UPI",
}

export default Codenames
